// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@keyframes slideUp-data-v-bb0ce3b4 {
to {
    --tw-translate-y: 0;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
}
.slide-up-animation-delayed[data-v-bb0ce3b4] {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  /**
    * Espera a que la web renderice
    * el primer contenido WOW.
    *
    * Mantiene el último estado
    * de la animación.
    */
  animation: slideUp-data-v-bb0ce3b4 250ms cubic-bezier(0.4,0.0,0.2,1) 1500ms 1 forwards
}
.cookies-banner[data-v-bb0ce3b4] {
  margin-left: auto;
  margin-right: auto;
  max-width: 28rem;
  padding: 30px 20px 16px 30px
}
@media (min-width: 768px) {
.cookies-banner[data-v-bb0ce3b4] {
    max-width: 36rem
}
}
@media (min-width: 1320px) {
.cookies-banner[data-v-bb0ce3b4] {
    max-width: 1100px;
    padding: 40px 30px 40px 138px
}
}
.cookies-banner[data-v-bb0ce3b4] {
  box-sizing: border-box;
  border-radius: 16px;
  --tw-bg-opacity: 1;
  background-color: rgb(249 237 196 / var(--tw-bg-opacity));
  font-size: 16px;
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  --tw-shadow: 0px 0px 7px 3px #00000017;
  --tw-shadow-colored: 0px 0px 7px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}
@media (min-width: 1320px) {
.cookies-banner[data-v-bb0ce3b4] {
    flex-direction: row
}
}
.cookies-banner__wrapper[data-v-bb0ce3b4] {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  box-sizing: border-box;
  padding: 1.5rem
}
@media (min-width: 640px) {
.cookies-banner__wrapper[data-v-bb0ce3b4] {
    right: auto
}
}
.cookies-banner a[data-v-bb0ce3b4] {
  text-decoration-line: underline
}
.cookies-banner a[data-v-bb0ce3b4]:hover {
  text-decoration-line: none
}
.cookies-banner__title[data-v-bb0ce3b4] {
  margin-bottom: 0.75rem;
  font-family: Mont;
  font-size: 1.375rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(31 47 75 / var(--tw-text-opacity))
}
.cookies-banner__buttons[data-v-bb0ce3b4] {
  display: flex;
  flex-direction: column;
  gap: 16px
}
@media (min-width: 768px) {
.cookies-banner__buttons[data-v-bb0ce3b4] {
    flex-direction: row-reverse;
    gap: 24px
}
}
@media (min-width: 1320px) {
.cookies-banner__buttons[data-v-bb0ce3b4] {
    align-items: flex-end
}
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/cookies/Banner.vue"],"names":[],"mappings":";AAmFA;AAEA;IAAA,mBAAA;IAAA;AAAA;AAEA;AAGA;EAAA,sBAAA;EAAA,+LAAA;EACA;;;;;;KAMA;EACA;AARA;AAYA;EAAA,iBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;AAAA;IAAA;AAAA;AAAA;AAAA;AAAA;IAAA,iBAAA;IAAA;AAAA;AAAA;AACA;EAAA,sBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,6CAAA;EACA,aAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,SAAA;EAAA,sCAAA;EAAA,2DAAA;EAAA;AADA;AACA;AAAA;IAAA;AAAA;AAAA;AAGA;EAAA,eAAA;EAAA,SAAA;EAAA,OAAA;EAAA,QAAA;EAAA,WAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;AAAA;IAAA;AAAA;AAAA;AAIA;EAAA;AAAA;AAGA;EAAA;AAAA;AAKA;EAAA,sBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA;AAAA;AAIA;EAAA,aAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;AAAA;IAAA,2BAAA;IAAA;AAAA;AAAA;AAAA;AAAA;IAAA;AAAA;AAAA","sourcesContent":["<template>\n  <Animation :duration=\"300\" leave=\"fadeOut\">\n    <div v-show=\"bannerOpen\" class=\"cookies-banner__wrapper\">\n      <div class=\"cookies-banner\">\n        <div>\n          <div class=\"cookies-banner__title\">Información sobre cookies</div>\n          <div class=\"cookies-banner__body\">\n            Utilizamos cookies propias y de terceros para fines analíticos y\n            para mostrarte publicidad personalizada en base a un perfil\n            elaborado a partir de tus hábitos de navegación (por ejemplo,\n            páginas visitadas). Puedes aceptar todas las cookies pulsando el\n            botón “Aceptar” o configurarlas o rechazar su uso pulsando el botón\n            “Configurar”.\n            <a target=\"_blank\" href=\"/legal/politica-de-cookies\"\n              >Más información</a\n            >\n          </div>\n        </div>\n        <div class=\"cookies-banner__buttons\">\n          <Button @click.native=\"accept\">Aceptar</Button>\n          <Button btn-style=\"secondary\" @click.native=\"openManager\"\n            >Configurar</Button\n          >\n          <Button btn-style=\"ghost\" @click.native=\"reject\">Rechazar</Button>\n        </div>\n      </div>\n    </div>\n  </Animation>\n</template>\n\n<script>\nimport Button from '@/lego/components/buttons/Button.vue';\nimport CookiesBus from '@/lego/utils/bus/cookies';\nimport {\n  shouldOpenBanner,\n  rejectLegalCookies,\n  acceptAllLegalCookies,\n} from '@/lego/utils/navigator/cookies';\nimport { onMounted, ref } from '@vue/composition-api';\nimport Animation from '@/lego/components/tools/Animation.vue';\n\nexport default {\n  components: { Button, Animation },\n\n  setup() {\n    const bannerOpen = ref(false);\n\n    CookiesBus.on('banner.open', () => {\n      bannerOpen.value = true;\n    });\n\n    CookiesBus.on('banner.close', () => {\n      bannerOpen.value = false;\n    });\n\n    function openManager() {\n      CookiesBus.emit('manager.open');\n    }\n\n    function accept() {\n      acceptAllLegalCookies();\n\n      CookiesBus.emit('manager.close');\n      CookiesBus.emit('banner.close');\n    }\n\n    function reject() {\n      rejectLegalCookies();\n\n      CookiesBus.emit('manager.close');\n      CookiesBus.emit('banner.close');\n    }\n\n    onMounted(() => {\n      bannerOpen.value = shouldOpenBanner();\n    });\n\n    return { bannerOpen, openManager, rejectLegalCookies, accept, reject };\n  },\n};\n</script>\n\n<style scoped lang=\"postcss\">\n@keyframes slideUp {\n  to {\n    @apply translate-y-0;\n  }\n}\n\n.slide-up-animation-delayed {\n  @apply translate-y-[100%];\n  /**\n    * Espera a que la web renderice\n    * el primer contenido WOW.\n    *\n    * Mantiene el último estado\n    * de la animación.\n    */\n  @apply animate-[slideUp_250ms_cubic-bezier(0.4,0.0,0.2,1)_1500ms_1_forwards];\n}\n\n.cookies-banner {\n  @apply max-w-md md:max-w-xl xl:max-w-[1100px] mx-auto p-[30px_20px_16px_30px] xl:p-[40px_30px_40px_138px];\n  @apply rounded-[16px] text-[#4B5563] bg-[#F9EDC4] text-[16px] box-border;\n  @apply flex flex-col xl:flex-row justify-between gap-xxxs shadow-[0px_0px_7px_3px_#00000017];\n\n  &__wrapper {\n    @apply fixed z-10 box-border bottom-0 left-0 right-0 sm:right-auto p-xxs;\n  }\n\n  a {\n    @apply underline;\n\n    &:hover {\n      @apply no-underline;\n    }\n  }\n\n  &__title {\n    @apply font-highlight text-[#1F2F4B] font-bold text-md mb-micro;\n  }\n\n  &__buttons {\n    @apply flex flex-col gap-[16px] md:flex-row-reverse md:gap-[24px] xl:items-end;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
